<template>
  <TDialog
    :visible="isModalOpen"
    :size="DialogSize.SM"
    :title="warningTitle"
    :title-icon="IconifyIcons.phoneXMarkFilled"
    :title-icon-color="iconColor"
    :warning="true"
    class="text-nash-neutral900"
    @close="emailInstead"
  >
    <p>{{ warningText }}</p>
    <template #actions>
      <TMSecondaryButton
        name="restricted-dial-call-anyway"
        label="Call anyway"
        @click="callAnyway"
      />
      <TMPrimaryButton
        class="ml-4"
        name="restricted-dial-email-instead"
        label="Email instead"
        @click="emailInstead"
      />
    </template>
  </TDialog>
</template>

<script lang="ts">
import TMPrimaryButton from '@thyme/nashville/src/components/button/TMPrimaryButton.vue'
import TMSecondaryButton from '@thyme/nashville/src/components/button/TMSecondaryButton.vue'
import TDialog from '@thyme/nashville/src/components/dialog/TDialog.vue'
import { defineComponent } from 'vue'
import setup from './controller'

export default defineComponent({
  components: {
    TDialog,
    TMPrimaryButton,
    TMSecondaryButton,
  },
  setup,
})
</script>
